<div class="flex justify-content-center">
    <div class="col-12 lg:col-6 xl:col-3 w-full px-0">
        <ng-container *ngIf="latestMoves?.length > 0; else noMovements">
            <div class="flex flex-column gap-2 p-3 surface-card border-round px-0" style="width: 100%;">
                <div class="flex align-items-center justify-content-between border-bottom-1 border-200 pb-3"
                    *ngFor="let move of latestMoves">
                    <!-- Date Column -->
                    <div class="flex flex-column align-items-center w-4rem">
                        <small class="text-600">{{ formatMonth(move.movementDate) }}</small>
                        <span class="text-900 text-xl font-semibold">{{ formatDay(move.movementDate) }}</span>
                    </div>

                    <!-- Info Section -->
                    <div class="flex flex-column flex-grow-1 pl-3 border-left-3 gap-2" [ngClass]="{
                  'border-red-500': move.enrollmentStatus === 'Overdue',
                  'border-yellow-400': move.enrollmentStatus === 'Upcoming',
                  'border-green-400': move.enrollmentStatus === 'Confirmed'
               }">

                        <!-- Students + Status -->
                        <div class="flex align-items-center justify-content-between">
                            <div class="flex align-items-center gap-2">
                                <small class="text-600 font-medium">{{ move.students?.length }} Students</small>
                                <span class="text-xs font-bold px-2 py-1 border-round" [ngClass]="{
                    'bg-red-100 text-red-500': move.enrollmentStatus === 'Overdue',
                    'bg-yellow-100 text-yellow-400': move.enrollmentStatus === 'Upcoming',
                    'bg-green-100 text-green-500': move.enrollmentStatus === 'Confirmed'
                  }">
                                    {{ move.enrollmentStatus }}
                                </span>
                            </div>

                            <!-- Avatar(s) -->
                            <!-- Avatar(s) with Tooltip -->
                            <div class="flex align-items-center" [pTooltip]="getStudentNames(move.students)"
                                tooltipPosition="left">
                                <ng-container *ngIf="move.students?.length > 0">

                                    <!-- Profile Image or Initials -->
                                    <ng-container *ngIf="move.students[0].profileimg; else initialsAvatar">
                                        <img [src]="move.students[0].profileimg" alt="avatar"
                                            class="w-2rem h-2rem border-circle" />
                                    </ng-container>

                                    <!-- Initials Fallback -->
                                    <ng-template #initialsAvatar>
                                        <div class="w-2rem h-2rem border-circle flex align-items-center justify-content-center text-white text-sm font-bold"
                                            [style.background-color]="getBackgroundColor(move.students[0].id)">
                                            {{ getInitials(move.students[0].name) }}
                                        </div>
                                    </ng-template>

                                    <!-- "+N" Circle -->
                                    <ng-container *ngIf="move.students.length > 1">
                                        <div
                                            class="w-2rem h-2rem border-circle flex align-items-center justify-content-center bg-gray-300 text-700 text-sm font-bold -ml-2">
                                            +{{ move.students.length - 1 }}
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>


                        </div>

                        <!-- Room Info -->
                        <span class="text-900 font-bold text-xs white-space-nowrap">
                            {{ move.currentRoom }} >
                            {{ move.isLeaving && move.nextRoomId === null ? 'Leaving the School' : move.nextRoom }}
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #noMovements>
            <div class="p-4 surface-card border-1 border-round border-300 text-center text-600"
                style="border-color: #e0e0e0;">
                <i class="pi pi-info-circle mr-2"></i> No movements available at the moment.
            </div>
        </ng-template>
    </div>
</div>